import { getAzureUser } from "../../API/User/User";

export async function enabledisableOnRuntime(
    context,
    type,
    url,
    orgId,
    instanceId,
    portalId,
    disabled
) {
    let token = localStorage.getItem("accessToken");

    let user = await getAzureUser(context)

    var requestOptions = {
        method: "POST",
        headers: {
            Authorization: "Bearer " + token,
            tokentype: "accesstoken"
        },
    };

    var baseURL = process.env.REACT_APP_RUNTIME_API_URL + "/api/ui/DisableRuntime?";
    var searchParams = new URLSearchParams();

    searchParams.append("type", type);
    searchParams.append("url", url);

    if (type === "Organization") {
        searchParams.append("orgId", orgId);
    } else if (type === "Application") {
        searchParams.append("orgId", orgId);
        searchParams.append("appId", instanceId);
    } else {
        searchParams.append("orgId", orgId);
        searchParams.append("appId", instanceId);
        searchParams.append("portalId", portalId);
    }

    searchParams.append("disabled", disabled);
    searchParams.append("userId", user.oid);

    let requestURL = baseURL + searchParams.toString();

    let request = await fetch(requestURL, requestOptions);

    let result = await request.json();

    return result;
}

export async function deleteOnRuntime(
    type,
    url,
    orgId,
    instanceId,
    portalId
) {

    let token = localStorage.getItem("accessToken");
    
    var requestOptions = {
        method: "POST",
        headers: {
            Authorization: "Bearer " + token,
            tokentype: "accesstoken"
        },
    };

    var baseURL = process.env.REACT_APP_RUNTIME_API_URL + "/api/ui/DeleteRuntime?";
    var searchParams = new URLSearchParams();

    searchParams.append("type", type);
    searchParams.append("url", url);

    if (type === "Organization") {
        searchParams.append("orgId", orgId);
    } else if (type === "Application") {
        searchParams.append("orgId", orgId);
        searchParams.append("appId", instanceId);
    } else {
        searchParams.append("orgId", orgId);
        searchParams.append("appId", instanceId);
        searchParams.append("portalId", portalId);
    }

    let requestURL = baseURL + searchParams.toString();

    let request = await fetch(requestURL, requestOptions);

    let result = await request.json();

    return result;
}